import React from 'react';

/**
 * reCAPTCHA Notice - Matches original ASTUDIO form exactly
 */
const RecaptchaNotice = () => {
  return (
    <div className="form-submit-note recaptcha-notice" style={{
      marginTop: '38px',
      lineHeight: '20px',
      fontSize: '14px',
      color: '#666666'
    }}>
      <p style={{ margin: 0 }}>
        This site is protected by reCAPTCHA and the Google{' '}
        <a
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            fontFamily: "'Neutra Text'",
            color: 'inherit',
            textDecoration: 'underline'
          }}
        >
          Privacy Policy
        </a>{' '}
        and{' '}
        <a
          href="https://policies.google.com/terms"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            fontFamily: "'Neutra Text'",
            color: 'inherit',
            textDecoration: 'underline'
          }}
        >
          Terms of Service
        </a>{' '}
        apply. By clicking Let's go, you're giving ASTUDIO permission to contact you with updates and offers. You can withdraw consent at any time. See our{' '}
        <a
          href="/privacy-policy/"
          style={{
            fontFamily: "'Neutra Text'",
            color: 'inherit',
            textDecoration: 'underline'
          }}
        >
          Privacy Policy
        </a>{' '}
        for more information.
      </p>
    </div>
  );
};

export default RecaptchaNotice;
